/* eslint-disable no-extra-boolean-cast */
import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import DatePicker from 'react-datepicker';
import { IconRightDecorator } from '../../../../../../components/Icon/IconRightDecorator';
import { Calendar } from '../../../../../../components/Icon';
import { Button } from '../../../../../../components/Buttons';
import { Checkbox } from '../../../../../../components/Checkbox';
import { Dropdown } from '../../../../../../components/Dropdown';
import { FormField } from '../../../../../../components/FormFields';
import { DecoratorLabel, Input } from '../../../../../../components/Input';
import { ManualDropdown } from '../../../../../../components/ManualDropdown';
import { Loader } from '../../../../../../components/Loader';
import {
  initiateNewVehicleValue,
  setNewVehicleValue,
  deleteVehicleProperty,
  calculatePurchasePriceInclVatExclBPM,
  setNewVehicle,
  retrieveRegplate,
  fetchVehicle,
  searchAutotelex,
  silverdatSearch,
  setNewVehicleOptions,
} from '../../../../../Vehicles/actions';
import { selectNewVehicle, selectNewVehicleValue, selectVehicle } from '../../../../../Vehicles/selectors';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { VehicleCreateFieldCompanyUser } from '../../../../../Vehicles/pages/create/FieldCompanyUser';

import { VehicleCreateFieldBrandName } from '../../../../../Vehicles/pages/create/FieldBrandName';
import { VehicleCreateFieldModelName } from '../../../../../Vehicles/pages/create/FieldModelName';
import {
  AUTOTELEX_VEHICLE_PURPOSE,
  CALCULATE_PURCHASE_PRICES_INCL_VAT_EXCL_BPM,
  REQUEST_SILVERDAT_GET,
  REQUEST_VEHICLE_PROPERTY_UPDATE,
  VEHICLE_PURPOSE,
  VEHICLE_TAX_TYPE,
} from '../../../../../Vehicles/constants';
import { COMMERCIAL_DEFAULTS_USER_IDS, REQUEST_COMPANIES } from '../../../../../Companies/constants';
import { selectWork, selectWorks } from '../../../../../Api/selectors';
import { selectCompany } from '../../../../../Companies/selectors';
import _ from 'lodash';
import { Well } from '../../../../../../components/Well';
import { HBox, VBox } from '../../../../../../components/Box';
import { OnMouseOverNotification } from '../../../../../Vehicles/components/OnMouseOverNotification';
import { fixPriceFormat } from '../../../../../../utils/string';
import env from '../../../../../../env';
import { AppClientId } from '../../../../../Shared/constants';
import { RegplateLabel } from '../../../../../Vehicles/components/RegplateLabel';

dayjs.extend(customParseFormat);

const MANUAL_DROPDOWN_OPTIONS = {
  tax_type: ['BTW', 'marge'],
  vehicle_purpose: [
    'passenger',
    'commercial',
    'Trekker/Vrachtwagen',
    'BW >3500kg',
    'Oplegger',
    'Aanhangwagen',
    'Landbouw- of bosbouwtrekker',
    'Motorfiets' ,
    'Bromfiets',
    'Klein materieel binnenopslag per m2',
    'Klein/middelgroot materieel buitenopslag <6m2',
    'Groot & afwijkend materieel buitenopslag >6m2',
    'chassiscabine_less_3500',
    'chassiscabine_greater_3500',
    'motor',
    'oplegger',
    'aanhanger',
  ],
};

const DROPDOWN_OPTIONS = {
  transport: ['is_available', 'pickup', 'develiver', 'anders'],
  is_owner: ['1', '0'],
};

const Container = styled.div`
  width: 100%;
  margin-bottom: 24px;
  .formField {
    .label {
      text-transform: capitalize;
      margin-bottom: 6px;
      color: #6c757d;
    }
  }

  .rightDecorationBlock {
    width: 100px;
    display: flex;

    .deleteBtn {
      background-color: #d50046;
    }
  }
`;

const STATE = {
  value: '',
};

/* eslint-disable react/prefer-stateless-function */
class VehicleCreateFieldComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {
    this.props.initiateValue();

    // if (this.props.type == 'buying_contact') {
    //   if (COMMERCIAL_DEFAULTS_USER_IDS.includes(+this.props.loggedInUserId)) {
    //     this.props.setValue(this.props.loggedInUserId, this.props.type);
    //   }
    // }
    // if (this.props.type == 'transport') {
    //   this.props.creditorCompany?.prefence_incoming_transport &&
    //     this.props.setValue(this.props.creditorCompany?.prefence_incoming_transport, this.props.type);
    // }

    // if (this.props.type == 'import' && !this.props.values?.import) {
    //   this.props.setValue('0', this.props.type);
    // }
  }

  isDate() {
    return ['date_expected'].indexOf(this.props.type) > -1;
  }

  isCheckbox() {
    return (
      [
        'new_from_factory',
        'import',
        'task_labels',
        //only hooikammer installation
        //only show following for hooikammer
        'artikelcode',
        'HOOI_uitslag_done',
        'ex_rental',
        'HOOI_standard_treatment',
        'HOOI_stalling',
        'HOOI_no_keys',
        'HOOI_task_extreme_cleaning',
        'HOOI_task_desticker',
        'HOOI_task_polish_exterior',
        'HOOI_no_keys',
        'HOOI_rolbaar',
        'HOOI_rijdbaar',
        'HOOI_niet_rolbaar',
        'HOOI_rijdbaar_slechte_accu',
        'make_tasks',
        'SALLAND_poetsen_compleet',
        'SALLAND_poetsen_binnenkant',
        'SALLAND_poetsen_buitenkant',
        'SALLAND_velgen_wisselen',
        'SALLAND_ozon_behandeling',
        'SALLAND_glascoating',
      ].indexOf(this.props.type) > -1
    );
  }

  isDropbox() {
    return this.props.type in DROPDOWN_OPTIONS;
  }

  isManualDropbox() {
    return this.props.type in MANUAL_DROPDOWN_OPTIONS;
  }

  wrap(children) {
    switch (this.props.type) {
      default:
        return <FormField label={this.formFieldLabel()}>{children}</FormField>;
    }
  }

  formFieldLabel() {
    if (this.isCheckbox()) return null;
    return this.lbl(`vehicle.property.${this.props.type}`);
  }

  dropdown() {
    const vals = DROPDOWN_OPTIONS[this.props.type];

    const options = vals.map(val => ({
      label: this.lbl(`vehicle.property.${this.props.type}.${val}`),
      value: val,
    }));

    const value = options.find(o => o.value == this.props.value);

    return <Dropdown options={options} value={value} onChange={pair => this.props.setValue(pair.value)} />;
  }

  manualDropdown() {
    const vals = MANUAL_DROPDOWN_OPTIONS[this.props.type];
    return (
      <ManualDropdown
        model={'vehicle'}
        key={this.props.type}
        type={this.props.type}
        editable={this.props.type != 'tax_type'}
        deletable={this.props.vehicle && this.props.vehicle[this.props.type]}
        options={vals}
        onChange={this.onChangePurchasePricesData.bind(this)}
        onReset={() => this.props.setValue('')}
        onDeleteValue={value =>
          this.props.deleteProperty(this.props.values?.id, this.props.type, result => {
            if (result === true) {
              this.props.setValue('');
            }
          })
        }
        onManual={value => {
          return this.props.setValue(value, this.props.type + '_manual');
        }}
      />
    );
  }

  datePicker() {
    let format = this.props.value?.charAt(2) == '-' ? 'DD-MM-YYYY' : undefined;
    let selected = this.props.value && dayjs(this.props.value, format);
    return (
      <>
        {' '}
        <DatePicker
          dateFormat="dd-MM-yyyy"
          selected={selected && selected.toDate()}
          onChange={date => {
            let d = dayjs(date).format('YYYY-MM-DD hh:mm:ss');
            this.props.setValue(d);
          }}
        />
        <IconRightDecorator icon={<Calendar />} />
      </>
    );
  }

  reset() {
    this.setState({ ...STATE });
  }

  onChangePurchasePricesData(evt) {
    this.props.type == 'financial_purchase_price_excl_vat_excl_bpm' ||
    this.props.type == 'financial_purchase_price_incl_vat_bpm' ||
    this.props.type == 'financial_purchase_price_marge_bpm' ||
    this.props.type == 'financial_purchase_price_marge_excl_bpm'
      ? this.props.setValue(evt.target.value)
      : this.props.setValue(evt);
    this._t = this.timeout(this.calculatePurchasePrice.bind(this), 1000, this._t);
  }

  calculatePurchasePrice() {
    if (!this.props.values['financial_purchase_price_excl_vat_excl_bpm']) {
      this.props.setValue('', 'financial_purchase_price_incl_vat_excl_bpm');
    }
    let financeField = '';
    if (
      (this.props.values?.tax_type === VEHICLE_TAX_TYPE.BTW &&
        this.props.values?.vehicle_purpose == VEHICLE_PURPOSE.Commercial) ||
      (this.props.values?.tax_type === VEHICLE_TAX_TYPE.BTW &&
        this.props.values?.vehicle_purpose == VEHICLE_PURPOSE.Passenger &&
        this.props.values?.import === '1')
    ) {
      financeField = 'financial_purchase_price_excl_vat_excl_bpm';
    }

    if (
      this.props.values?.tax_type === VEHICLE_TAX_TYPE.BTW &&
      this.props.values?.vehicle_purpose == VEHICLE_PURPOSE.Passenger &&
      this.props.values?.import === '0'
    ) {
      financeField = 'financial_purchase_price_incl_vat_bpm';
    }

    if (
      this.props.values?.tax_type === VEHICLE_TAX_TYPE.Marge &&
      this.props.values?.vehicle_purpose == VEHICLE_PURPOSE.Passenger
    ) {
      financeField = 'financial_purchase_price_marge_bpm';
    }

    if (
      this.props.values?.tax_type === VEHICLE_TAX_TYPE.Marge &&
      this.props.values?.vehicle_purpose == VEHICLE_PURPOSE.Commercial
    ) {
      financeField = 'financial_purchase_price_marge_excl_bpm';
    }

    if (
      this.props.values?.tax_type === VEHICLE_TAX_TYPE.Marge &&
      this.props.values?.vehicle_purpose == VEHICLE_PURPOSE.Passenger &&
      this.props.values?.import === '1'
    ) {
      financeField = 'financial_purchase_price_marge_excl_bpm';
    }

    const dto = {
      source: this.props.companySource,
      btwOrMarge: this.props.values?.tax_type,
      vehiclePurpose: this.props.values?.vehicle_purpose,
      isImported: this.props.values?.import === '1',
      buyerType: this.props.companyType || 0,
      rest_bpm: +this.props.values?.rest_bpm ? fixPriceFormat(+this.props.values?.rest_bpm) : fixPriceFormat(0),
      financial_bpm_gross: +this.props.values?.financial_bpm_gross || 0,
    };

    if (financeField) dto[financeField] = +this.props.values[financeField] || 0;

    this.props.calculatePurchasePrices(dto, result => {
      if (Object.keys(result)?.length) {
        Object.keys(result)?.map(price => {
          if ((price === 'outgoing_rest_bpm' || price === 'rest_bpm') && !result[price]) {
            return;
          }
          if (result[price] == 0) {
            if (price === 'rest_bpm') {
              return this.props.setValue(fixPriceFormat(result[price]), price);
            }
            return this.props.setValue('', price);
          }

          return this.props.setValue(result[price], price);
        });
      }
    });
  }

  render() {
    if (this.props.work) return <Loader small />;
    if (this.props.companyWork && this.props.type == 'buying_contact') return <Loader small />;
    return <Container>{this.wrap(this.renderField())}</Container>;
  }

  onRegplateRetrieve = () => {
    const dto = { regplate: this.props.value };
    this.props.searchAutotelex(dto, res => {
      if (!!res) {
        let retrievedVehicle = res?.properties?.reduce((acc, next) => {
          if (
            next?.propertyName == AUTOTELEX_VEHICLE_PURPOSE.PropertyName &&
            next.propertyValue == AUTOTELEX_VEHICLE_PURPOSE.Passenger
          ) {
            return { ...acc, [next.propertyName]: next.propertyValue, vehicle_purpose: VEHICLE_PURPOSE.Passenger };
          }

          if (
            next?.propertyName == AUTOTELEX_VEHICLE_PURPOSE.PropertyName &&
            next.propertyValue == AUTOTELEX_VEHICLE_PURPOSE.Commercial
          ) {
            return { ...acc, [next.propertyName]: next.propertyValue, vehicle_purpose: VEHICLE_PURPOSE.Commercial };
          }

          return { ...acc, [next.propertyName]: next.propertyValue };
        }, {});
        console.log('RV: ', retrievedVehicle);
        if (retrievedVehicle?.taxiVerleden === '1') {
          retrievedVehicle.rest_bpm = fixPriceFormat(0);
          retrievedVehicle.outgoing_rest_bpm = fixPriceFormat(0);
        }
        this.props.setNewVehicle(retrievedVehicle);
        this.props.setNewVehicleOptions(res.options);

        if (res?.ownerHistory) {
          this.props.setValue(JSON.stringify(res?.ownerHistory), 'ownerHistory');
        }
      }
    });
  };

  onVinRetrieve = () => {
    const dto = { vin: this.props.value };
    this.props.searchVIN(dto, res => {
      if (res.error) return this.setState({ error: res.error });
      let vehicle = Object.keys(res.Vehicle).map(name => ({ name, value: res.Vehicle[name]?.Value }));
      this.setState({ vinResults: { vehicle } });
    });
  };

  disableCalculatedFields(type) {
    return this.props.workCalc && this.props.type != type;
  }

  renderField() {
    if (this.isCheckbox()) {
      return (
        <Checkbox
          checked={this.props.value === '1'}
          onChange={() => {
            const value = this.props.value === '1' ? '0' : '1';
            return this.props.setValue(value);
          }}
        >
          {this.lbl(`vehicle.property.${this.props.type}`)}
        </Checkbox>
      );
    }

    if (this.isDate()) {
      return this.datePicker();
    }

    if (this.isDropbox()) {
      return this.dropdown();
    }

    if (this.isManualDropbox()) {
      return this.manualDropdown();
    }

    switch (this.props.type) {
      case 'regplate':
        return (
          <VBox>
            <Input
              key={this.props.type}
              value={this.props.value}
              onChange={evt => this.props.setValue(evt.target.value)}
              rightDecoration={
                <div className="rightDecorationBlock">
                  <Button disabled={!this.props.values.regplate} onClick={this.onRegplateRetrieve}>
                    {this.lbl('vehicle.create.regplate.retrieve')}
                  </Button>
                  {this.props.edit && (
                    <Button
                      small
                      disabled={!this.props.vehicle?.regplate}
                      className="deleteBtn"
                      onClick={() =>
                        this.props.deleteProperty(this.props.values?.id, 'regplate', result => {
                          if (result === true) {
                            this.props.setValue('');
                          }
                        })
                      }
                    >
                      {this.lbl('vehicle.create.regplate.X')}
                    </Button>
                  )}
                </div>
              }
            />
            <RegplateLabel regplate={this.props.value?.length >= 3 ? this.props.value : 'nummer'} height="36" />
          </VBox>
        );
      case 'vin':
        if (this.props.findingVIN) return <Loader small />;
        return (
          <VBox>
            {this.state.error ? <Well alert>{this.state.error}</Well> : null}
            <Input
              key={this.props.type}
              value={this.props.value}
              onChange={evt => this.props.setValue(evt.target.value.toUpperCase())}
              style={{ width: '100%' }}
              // rightDecoration={<Button>{this.lbl('vehicle.create.vin.retrieve')}</Button>}
            />
            {this.state.vinResults?.vehicle ? (
              <div>
                {this.state.vinResults.vehicle.map(result => (
                  <div key={result.name} style={{ marginBottom: '4px' }}>
                    <strong>{result.name}</strong>
                    <br />
                    {result.value}
                  </div>
                ))}
              </div>
            ) : null}
          </VBox>
        );
      case 'buying_contact':
        return (
          <VehicleCreateFieldCompanyUser
            homeUsers={this.props.homeUsers}
            key={`${this.props.type}`}
            type={this.props.type}
            onChange={value => this.props.setValue(value)}
          />
        );
      case 'brand_name':
        console.log('brand_name is loaded correctly -------------------');
        return (
          <VehicleCreateFieldBrandName
            key={this.props.type}
            type={this.props.type}
            deletable={this.props.vehicle && this.props.vehicle[this.props.type]}
            onReset={() => {
              this.props.setValue('');
              this.props.setValue('', 'model_name');
            }}
            onChange={value => this.props.setValue(value)}
            onDeleteValue={value =>
              this.props.deleteProperty(this.props.values?.id, this.props.type, result => {
                if (result === true) {
                  this.props.setValue('');
                  this.props.setValue('', 'model_name');
                }
              })
            }
            onManual={value => this.props.setValue(value, this.props.type + '_manual')}
          />
        );

      case 'model_name':
        return (
          <VehicleCreateFieldModelName
            key={this.props.type}
            type={this.props.type}
            deletable={this.props.vehicle && this.props.vehicle[this.props.type]}
            onChange={value => this.props.setValue(value)}
            onReset={() => this.props.setValue('')}
            onDeleteValue={value => this.props.deleteProperty(this.props.values?.id, this.props.type, result => {})}
            onManual={value => this.props.setValue(value, this.props.type + '_manual')}
          />
        );
      case 'financial_price_b2c':
        return (
          <Input
            type="number"
            key={this.props.type}
            value={this.props.value}
            onChange={evt => this.props.setValue(evt.target.value)}
            rightDecoration={<DecoratorLabel>€</DecoratorLabel>}
          />
        );

      case 'extra_cost_transport_kosten_inkomend':
        return (
          <Input
            type="number"
            key={this.props.type}
            value={this.props.value}
            onChange={evt => {
              this.props.setValue(evt.target.value);
              this.props.setValue(evt.target.value, 'extra_cost_sum');
            }}
            rightDecoration={<DecoratorLabel>€</DecoratorLabel>}
          />
        );

      case 'financial_purchase_price_incl_vat_excl_bpm':
        return (
          <Input
            disabled={true}
            type="number"
            key={this.props.type}
            value={this.props.value}
            onChange={evt => this.props.setValue(evt.target.value)}
            rightDecoration={<DecoratorLabel>€</DecoratorLabel>}
          />
        );
      case 'financial_purchase_price_marge_bpm':
        return (
          <Input
            type="number"
            key={this.props.type}
            value={this.props.value}
            disabled={this.disableCalculatedFields('financial_purchase_price_marge_bpm')}
            onChange={this.onChangePurchasePricesData.bind(this)}
            rightDecoration={<DecoratorLabel>€</DecoratorLabel>}
          />
        );
      case 'financial_price_b2b_incl_vat_btpm':
        return (
          <Input
            type="number"
            key={this.props.type}
            value={this.props.value}
            onChange={evt => this.props.setValue(evt.target.value)}
            rightDecoration={<DecoratorLabel>€</DecoratorLabel>}
          />
        );
      case 'financial_purchase_price_excl_vat_excl_bpm':
        return (
          <Input
            type="number"
            key={this.props.type}
            value={this.props.value}
            disabled={this.disableCalculatedFields('financial_purchase_price_excl_vat_excl_bpm')}
            onChange={this.onChangePurchasePricesData.bind(this)}
            rightDecoration={<DecoratorLabel>€</DecoratorLabel>}
          />
        );
      case 'rest_bpm':
        return (
          <HBox vCenter>
            <Input
              key={this.props.type}
              value={this.props.value}
              onChange={evt => this.props.setValue(evt.target.value)}
              rightDecoration={<DecoratorLabel>€</DecoratorLabel>}
            />
            {this.props.values.taxiVerleden === '1' && (
              <OnMouseOverNotification top="-250px" right="100px" message={this.lbl('alert.is_taxi_tax_message')} />
            )}
          </HBox>
        );

      case 'mileage':
        return (
          <Input
            key={this.props.type}
            value={this.props.value}
            onChange={evt => this.props.setValue(evt.target.value)}
            rightDecoration={<DecoratorLabel>KM</DecoratorLabel>}
          />
        );
      case 'financial_purchase_price_incl_vat_bpm':
        return (
          <Input
            type="number"
            key={this.props.type}
            value={this.props.value}
            disabled={this.disableCalculatedFields('financial_purchase_price_incl_vat_bpm')}
            onChange={this.onChangePurchasePricesData.bind(this)}
            rightDecoration={<DecoratorLabel>€</DecoratorLabel>}
          />
        );
      case 'financial_purchase_price_marge_excl_bpm':
        return (
          <Input
            type="number"
            key={this.props.type}
            disabled={this.disableCalculatedFields('financial_purchase_price_marge_excl_bpm')}
            value={this.props.value}
            onChange={this.onChangePurchasePricesData.bind(this)}
            rightDecoration={<DecoratorLabel>€</DecoratorLabel>}
          />
        );
      case 'helga_id':
        return (
          <Input key={this.props.type} value={this.props.value} onChange={evt => this.props.setValue(evt.target.value)} />
        );
      case 'articlecode':
        return (
          <Input key={this.props.type} value={this.props.value} onChange={evt => this.props.setValue(evt.target.value)} />
        );
        case 'category_id':
          return (
            <Input key={this.props.type} value={this.props.value} onChange={evt => this.props.setValue(evt.target.value)} />
          );
      case 'workflowId':
        const vals = this.props.availableWorkflows ?? [];

        const options = vals.map(val => ({
          value: val.id,
          label: val.name,
        }));

        const value = options.find(o => o.value == this.props.value);

        return (
          
          <Dropdown
            options={options}
            value={value}
            onChange={pair => {
              this.props.setValue(pair.value);
              this.props.onSelectWorkflow(pair.value);
            }}
          />
        );
      default:
        return <h1>Hello</h1>;
    }
  }
}

VehicleCreateFieldComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWork(REQUEST_VEHICLE_PROPERTY_UPDATE),
    findingVIN: selectWork(REQUEST_SILVERDAT_GET),
    workCalc: selectWorks([CALCULATE_PURCHASE_PRICES_INCL_VAT_EXCL_BPM]),
    companyWork: selectWork(REQUEST_COMPANIES),
    value: selectNewVehicleValue(ownProps.type),
    values: selectNewVehicle(),
    vehicle: selectVehicle(ownProps.vehicle_id),
    creditorCompany: selectCompany(ownProps.creditorCompanyId),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    setValue(value, name = null) {
      name = name ?? ownProps.type;
      dispatch(setNewVehicleValue(name, value));
    },
    deleteProperty(vehicleId, propertyName, callback) {
      dispatch(deleteVehicleProperty(vehicleId, propertyName, callback));
    },
    initiateValue() {
      dispatch(initiateNewVehicleValue(ownProps.type));
    },
    calculatePurchasePrices(enteredAmounts, callback) {
      dispatch(calculatePurchasePriceInclVatExclBPM(enteredAmounts, callback));
    },
    fetchVehicle(regplate, callback) {
      dispatch(retrieveRegplate(regplate, callback));
    },
    fetchVehicleById(vehicleId, callback) {
      dispatch(fetchVehicle(vehicleId, callback));
    },
    setNewVehicle(data, isAutotelex) {
      dispatch(setNewVehicle(data, isAutotelex));
    },
    setNewVehicleOptions(options) {
      dispatch(setNewVehicleOptions(options));
    },
    searchAutotelex(dto, callback) {
      dispatch(searchAutotelex(dto, callback));
    },
    searchVIN(dto, callback) {
      dispatch(silverdatSearch(dto, callback));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const VehicleCreateField = compose(withConnect, withRouter)(VehicleCreateFieldComp);
